import React, { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { categoryGroupTagsState } from '../../../../../common/atoms/checkout'
import Role from './Role'
import { CategoryProfileResponse } from '../../../../../types/users/category-profile-response'
import { useTranslation } from 'next-i18next'
import groupBy from 'lodash.groupby'

type Props = {
  profile?: CategoryProfileResponse
  currentRolesState: any
}

export default function PreferredRoles({ profile, currentRolesState }: Props) {
  const [, setCurrentRoleState] = currentRolesState
  const { t } = useTranslation('inGameModal')
  const [groupedTags] = useRecoilState(categoryGroupTagsState)

  useEffect(() => {
    if (profile && profile.categorySpecializedTags) {
      let roles = groupBy(
        profile.categorySpecializedTags,
        (item) => item.parent.name,
      )

      roles['Roles']?.forEach(function (value) {
        // @ts-ignore
        setCurrentRoleState((preState) => ({ ...preState, [value.id]: true }))
      })
    }
  }, [profile])

  return (
    <div>
      {/*No Account*/}
      <div className={'flex flex-col'}>
        <div className={'flex flex-row items-center gap-2.5'}>
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M11.1918 12.5H3.66679C2.15012 12.5 1.18345 10.875 1.91678 9.5417L3.85845 6.00835L5.67512 2.70001C6.43345 1.32501 8.41678 1.32501 9.17512 2.70001L11.0001 6.00835L11.8751 7.60002L12.9418 9.5417C13.6751 10.875 12.7085 12.5 11.1918 12.5Z'
              stroke='#050608'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M18.3333 12.9167C18.3333 15.9083 15.9083 18.3333 12.9167 18.3333C9.925 18.3333 7.5 15.9083 7.5 12.9167C7.5 12.775 7.50833 12.6417 7.51667 12.5H11.1917C12.7083 12.5 13.675 10.875 12.9417 9.54168L11.875 7.6C12.2083 7.53333 12.5583 7.5 12.9167 7.5C15.9083 7.5 18.3333 9.925 18.3333 12.9167Z'
              stroke='#050608'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>

          <p className={'text-body-medium text-fizz-1000'}>
            {t('PreferredRolesTitle')}
          </p>
        </div>

        <div className='mt-2 grid w-full grid-cols-6 gap-x-2 gap-y-1'>
          {groupedTags['Roles']?.map((item) => {
            return (
              <div className={'col-span-3'} key={item.name}>
                <Role
                  checkOption={item.name}
                  rolesState={currentRolesState}
                  categoryId={item.id}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
